export const OPEN_RATE_BROWSER_MODAL = 'OPEN_RATE_BROWSER_MODAL';
// TODO add ability to open from CSW
export const openRateBrowserModal = (rateBrowserDefaults, shouldBypassOpeningRateBrowserModalWithEpic = false) => ({
  type: OPEN_RATE_BROWSER_MODAL,
  rateBrowserDefaults,
  shouldBypassOpeningRateBrowserModalWithEpic,
});

export const RATE_BROWSER_SET_MODAL_ID = 'RATE_BROWSER_SET_MODAL_ID';
export const setModalId = (modalId) => ({
  type: RATE_BROWSER_SET_MODAL_ID,
  modalId,
});

export const RATE_BROWSER_BACK_TO_RATES = 'RATE_BROWSER_BACK_TO_RATES';
export const backToRates = () => ({
  type: RATE_BROWSER_BACK_TO_RATES,
});

export const CLOSE_RATE_BROWSER_MODAL = 'CLOSE_RATE_BROWSER_MODAL';
export const closeRateBrowserModal = () => ({
  type: CLOSE_RATE_BROWSER_MODAL,
});

export const RESET_RATE_BROWSER_MODAL = 'RESET_RATE_BROWSER_MODAL';
export const resetRateBrowserModal = () => ({
  type: RESET_RATE_BROWSER_MODAL,
});

export const UPDATE_CONFIGURE_RATES_MODEL = 'UPDATE_CONFIGURE_RATES_MODEL';
export const updateConfigureRatesModel = (updatePayload) => ({
  type: UPDATE_CONFIGURE_RATES_MODEL,
  updatePayload,
});

export const UPDATE_RATE_BROWSER_SHIP_FROM_ID = 'UPDATE_RATE_BROWSER_SHIP_FROM_ID';
export const updateRateBrowserShipFromId = (shipFromId) => ({
  type: UPDATE_RATE_BROWSER_SHIP_FROM_ID,
  shipFromId,
});
